import { TMessageSchema, TOutcomingStatus, IParsedMessage, TMessagesMap } from '../../types/messages';
import { processRawMessage } from './processRawMessage';
import { updateMessageIndexInMap } from './updateMessageIndexInMap';

interface IInsertMessageIntoChatMessagesParams {
  messagesMap: TMessagesMap;
  rawMessage: TMessageSchema;
  chatMessages: IParsedMessage[];
  userId: number;
  status?: TOutcomingStatus;
}

/**
 * @description
 * Добавляет rawMessage в chatMessages
 */
export function insertMessageIntoChatMessages({
  messagesMap,
  rawMessage,
  chatMessages,
  userId,
  status,
}: IInsertMessageIntoChatMessagesParams) {
  const nextChatMessages = processRawMessage({
    rawMessage,
    messagesMap,
    currentChatMessages: chatMessages,
    userId,
    status,
  });

  if (nextChatMessages.length !== chatMessages.length) {
    updateMessageIndexInMap({ chatMessages: nextChatMessages, messagesMap });
  }

  return nextChatMessages;
}
